import arrowNavigate from "./arrowNavigate";
import closeDropdown from "./closeDropdown";

export default function(event) {
  let noMatch = false;

  switch (event.key) {
  case "Escape":
    closeDropdown(this);
    break;
  case "ArrowDown":
    arrowNavigate(this, "down");
    break;
  case "ArrowUp":
    arrowNavigate(this, "up");
    break;
  case "Enter":
    this.onEnterKeydown();
    break;
  default:
    noMatch = true;
  }

  if (noMatch) return; 
  event.stopPropagation();
  event.preventDefault();
}
